import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/bank/accounts-by-bank-product`

export default ({ id }) => http.get(`${api}/${id}`)
